import Schools from "./schools";

const schoolsPageRoutes = [{ path: "/escolas", element: <Schools /> }];

export default schoolsPageRoutes;
